<script lang="ts">
	import type { LayoutData } from './$types';
	import Hero from '@app/components/cms/Hero.svelte';
	import PageHead from '@app/components/PageHead.svelte';
	import NarrowInnerContainer from '@app/components/cms/layouts/NarrowInnerContainer.svelte';
	import { storyblokEditable } from '@storyblok/svelte';
	import { checkCMSBanner } from '@app/utils/cms';

	export let data: LayoutData;

	$: data.story?.content.banner && checkCMSBanner(data.story?.content.banner);
</script>

{#if data.story?.content}
	<PageHead title={data.story?.content?.metaTitle} desc={data.story?.content?.metaDescription} />

	<div class="page-stack cms-layout pb-6" use:storyblokEditable={data.story?.content}>
		<section>
			<Hero props={data.story?.content} />
		</section>
		{#if typeof data.story?.content?.subtitle === 'string'}
			<section>
				<div class="container">
					<NarrowInnerContainer>
						<h2 class="text-center">{data.story?.content?.subtitle}</h2>
					</NarrowInnerContainer>
				</div>
			</section>
		{/if}
		{#if data.story?.content?.desc}
			<section>
				<div class="container">
					<NarrowInnerContainer>
						<p class="font-display text-xl">{data.story?.content?.desc}</p>
					</NarrowInnerContainer>
				</div>
			</section>
		{/if}
		<slot />
	</div>
{/if}
